/**
 * +field: level scaling (docs/design/zones.md "Levelling"). One curve scales heroes (max HP,
 * power) and mobs (HP, damage) alike, so an even-level fight takes the same time at level 2 and
 * level 9; a mob above you is LEVEL_STEP stronger per level. Level 10 is the M+ baseline (×1).
 */
import type { ScalingMults } from '../contracts';

/** Growth per level (heroes and mobs). */
export const LEVEL_STEP = 1.09;
/** The level whose multiplier is exactly 1 (the unlevelled M+ baseline). */
export const LEVEL_BASELINE = 10;

/** HP / power / damage multiplier at `level` (clamped to 1..60). */
export function levelMult(level: number): number {
  const l = Math.max(1, Math.min(60, Math.floor(level) || 1));
  return LEVEL_STEP ** (l - LEVEL_BASELINE);
}

/** NPC scaling for a mob of `level` (HP and damage). */
export function levelScaling(level: number): ScalingMults {
  const m = levelMult(level);
  return { hp: m, damage: m };
}
